import { loadStripe } from '@stripe/stripe-js'
import i18n from '../i18n'

let platformStripePromise
const connectedAccountStripePromises = {}

// Stripe.js takes the language of its error strings from the instance, not from the Elements options
export function getPlatformStripe() {
  if (!platformStripePromise) {
    platformStripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, { locale: i18n.language })
  }

  return platformStripePromise
}

// The program fee invoice lives on the community's connected account, so its card form and
// its confirmation both need a Stripe instance scoped to that account
export function getConnectedAccountStripe(stripeAccountId) {
  if (!connectedAccountStripePromises[stripeAccountId]) {
    connectedAccountStripePromises[stripeAccountId] = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
      stripeAccount: stripeAccountId,
      locale: i18n.language,
    })
  }

  return connectedAccountStripePromises[stripeAccountId]
}

// No account of its own means ours: the membership is billed by the platform, the coaching fee by the club
export function getStripeForAccount(stripeAccountId) {
  return stripeAccountId ? getConnectedAccountStripe(stripeAccountId) : getPlatformStripe()
}

// Deferred mode: the amount is the one intent this form will confirm, never the combined total of the checkout
export function deferredElementsOptions({ stripeAccountId, mode, amount, currency, captureMethod }) {
  return {
    mode,
    amount,
    currency,
    paymentMethodTypes: ['card'],
    // Stripe.js refuses a confirm whose capture method disagrees with the intent's
    ...(captureMethod && { captureMethod }),
    // Stripe.js refuses createPaymentMethod without it, and only the platform mount creates a card to clone
    ...(!stripeAccountId && { paymentMethodCreation: 'manual' }),
    locale: i18n.language,
    appearance: {
      variables: {
        colorPrimary: '#ff6633',
        colorText: '#1d2933',
        colorTextPlaceholder: '#9aa1ab',
        borderRadius: '10px',
        fontFamily: '"Lato", sans-serif',
        fontSizeBase: '15px',
        focusOutline: 'none',
        focusBoxShadow: '0 0 0 1px #ff6633',
      },
      rules: {
        '.Input': { borderColor: '#c3c9d1', padding: '12px 14px', lineHeight: '1.5' },
        '.Input:focus': { borderColor: '#ff6633' },
      },
    },
  }
}
